"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBrowser = isBrowser;
exports.scheduleMicrotaskWithFallback = scheduleMicrotaskWithFallback;
exports.waitFor = waitFor;

/**
 * Schedules a microtask if possible, with safe fallbacks
 */
function scheduleMicrotaskWithFallback(fn) {
  if (typeof queueMicrotask === 'function') {
    queueMicrotask(fn);
    return;
  }

  if (typeof Promise !== 'undefined') {
    Promise.resolve().then(fn);
    return;
  }

  setTimeout(fn, 0);
}
/**
 * Check if running in browser environment
 */


function isBrowser() {
  return (globalThis === null || globalThis === void 0 ? void 0 : globalThis.window) !== undefined;
}
/**
 * Utility: Delay execution until a condition is true
 */


function waitFor(condition, callback) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
  var start = performance.now();

  var check = function check() {
    if (condition()) {
      callback();
      return;
    }

    if (performance.now() - start > timeout) {
      return;
    }

    requestAnimationFrame(check);
  };

  check();
}